export default function ArtworkCard({ art, onClick }) {
  return (
    <article
      className="group cursor-pointer"
      onClick={onClick}
      data-testid={`artwork-card-${art.id}`}
    >
      <div className="art-frame aspect-[4/5] border border-[#2A2A2A]">
        <img src={art.image_url} alt={art.title} loading="lazy" />
      </div>
      <div className="pt-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-display text-lg sm:text-xl leading-tight">{art.title}</h3>
          <p className="text-xs text-[#9a9484] mt-1">
            {art.technique} · {art.size} · {art.year}
            {art.edition ? ` · ed. ${art.edition}` : ""}
          </p>
        </div>
        <div className="text-right shrink-0">
          <p className="font-display font-bold text-lg">
            {art.price ? `€${art.price.toLocaleString("it-IT")}` : "Su richiesta"}
          </p>
          {art.nft && (
            <span className="inline-block mt-1 text-[10px] uppercase tracking-[0.15em] text-[#D4AF37] border border-[#D4AF37] px-2 py-0.5">
              NFT · {art.nft_platform}
            </span>
          )}
          {art.editions_left != null && (
            <p className="text-[10px] text-[#9a9484] mt-1.5" data-testid={`editions-left-${art.id}`}>
              Riproduzioni: {art.editions_left}/10 disponibili
            </p>
          )}
        </div>
      </div>
    </article>
  );
}
